import React from 'react';

import { StatisticsView } from '@ndvr/reporting-api';

import { Card } from '@/components/ui/card';
import { cn } from '@/utils/cn';

import { GlossaryLabel } from '../../reporting/GlossaryInfoButton';
import { HEAD_CLASS, TABLE_CARD_HEADER_CLASS, TABLE_CLASS } from '../../reporting/table-styles';
import { periodLabel, RELATIVE_STATISTIC_ROWS } from '../statistics-format';

interface RelativeStatisticsCardProps {
    view: StatisticsView;
}

// Account-versus-benchmark relative statistics (beta, alpha, capture ratios, …) per
// trailing window — the "Relative statistics" card of the Advanced Analytics design.
export const RelativeStatisticsCard = ({ view }: RelativeStatisticsCardProps) => (
    <Card className="border-border overflow-hidden rounded-2xl border bg-white">
        <div className={cn(TABLE_CARD_HEADER_CLASS, 'border-b')}>
            <h3 className="font-heading text-cocoa-1000 text-xl">Relative statistics</h3>
            <span className="text-cocoa-400 text-xs">Versus {view.benchmarkName}</span>
        </div>
        <table className={cn('w-full', TABLE_CLASS)}>
            <thead>
                <tr className="border-b">
                    <th className="w-[40%] px-4 py-2.5" />
                    {view.windows.map((window) => (
                        <th key={window.period} className={`${HEAD_CLASS} px-4 py-2.5 text-right`}>
                            {periodLabel(window.period)}
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {RELATIVE_STATISTIC_ROWS.map(({ label, value, glossaryKey }) => (
                    <tr key={label} className="border-b last:border-b-0">
                        <td className="text-cocoa-900 px-4 py-3 text-sm">
                            <GlossaryLabel label={label} glossaryKey={glossaryKey} />
                        </td>
                        {view.windows.map((window) => (
                            <td
                                key={window.period}
                                className="text-cocoa-500 px-4 py-3 text-right text-sm tabular-nums"
                            >
                                {value(window)}
                            </td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    </Card>
);
